var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerIt"},[_c('div',{staticClass:"d-flex flex-row"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',{staticClass:"ml-8 text-h5"},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }